import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { QsPreview } from '@/components'
let { WizContainer } = framework_tool
let { WizSpin } = component_tool
let { Session } = utils_tool

const getParamRecord = (history) => {
    let record = {}
    if (history.location && (history.location.pathname === '/biz/survey/surveyRecordInfo/surveyRecordInfoDetail'
        || history.location.pathname === '/workflow/apply/applyInfo/surveyRecordInfoDetail'
        || history.location.pathname === '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfoDetail'
    )) {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('surveyRecordInfoDetail', record)
        } else {
            record = Session.get('surveyRecordInfoDetail') || {}
        }
    }
    return record
}

class surveyRecordInfoDetail extends WizContainer {

    componentName = 'surveyRecordInfoDetail'

    constructor(props) {
        super(props)
        let { history } = props
        this.record = getParamRecord(history)
    }

    _render() {
        return (
            <QsPreview data={{ ...this.record, preview: false }} />
        )
    }
}


export default surveyRecordInfoDetail
